module.exports = __webpack_public_path__ + "static/GarethA-82254621ea5983894ebb132e8d23e6ce.gif";